module.exports = __webpack_public_path__ + "img/share-icon-white.f782a64f.svg";